import React from 'react'

const Footer = () => {
  return (
    <footer>
      <a href="https://www.facebook.com/unmomentasoi1/" target="_blank" className="fa fa-facebook-official fa-2x" /><br />
      <p>
        <i className="fa fa-copyright" /> UnMomentASoi.eu
      </p>
      <p>
        Conception web originale <a href="http://feedbydesign.com" target="_blank" className="feed">Feed by Design</a><br />
        Toutes les photos et illustrations utilisées sur ce site sont la propriété de Tess Hadri à l'usage de Florence Volant
      </p>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/Footer.js